import styled from '@app/styled';
import { mediaQuery } from '@app/theme';

export const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 30px;
`;

export const Wrapper = styled.div`
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 70vh;
    margin: 90px auto;

    ${mediaQuery.max('md')} {
        display: none;
    }
`;
export const LeftImage = styled.img`
    align-self: flex-end;
`;
export const RightImage = styled.img`
    align-self: flex-start;
`;
